import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">A B I N </span>
            from <span className="purple"> Kannur, India.</span>
            <br />
            I am currently employed as a software developer at firebase dev.
            <br />
            I learned JavaScript python smalidev and perfected.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing About Tech
            </li>
            <li className="about-activity">
              <ImPointRight /> Review
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">A B I N</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
